module.exports = __webpack_public_path__ + "assets/tutIcon.e26da8cb1e01d634e65bf8acfff8fa04.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/svg/stars/tutIcon.svg
// module id = 872
// module chunks = 0